import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPastTestResults = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20 7.64522C20 6.07967 18.731 4.81055 17.1655 4.81055H5.83451C4.26908 4.81055 3.00004 6.07967 3.00004 7.64522L3 15.1981C3 16.7636 4.26903 18.0328 5.83446 18.0328H17.1655C18.7309 18.0328 20 16.7636 20 15.1981L20 7.64522Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9504 9.19412L11.6556 13.4889L9.16123 10.9945L6.77797 13.3781",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.53868 19.2248L7.78589 18.4639L6.2642 17.9695L6.01699 18.7303L7.53868 19.2248ZM5.72514 19.6285C5.58861 20.0487 5.81857 20.5001 6.23877 20.6366C6.65897 20.7731 7.1103 20.5432 7.24683 20.123L5.72514 19.6285ZM6.01699 18.7303L5.72514 19.6285L7.24683 20.123L7.53868 19.2248L6.01699 18.7303Z",
			fill: "#8A94A6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4618 19.2248L15.2146 18.4639L16.7363 17.9695L16.9835 18.7303L15.4618 19.2248ZM17.2754 19.6285C17.4119 20.0487 17.1819 20.5001 16.7617 20.6366C16.3415 20.7731 15.8902 20.5432 15.7537 20.123L17.2754 19.6285ZM16.9835 18.7303L17.2754 19.6285L15.7537 20.123L15.4618 19.2248L16.9835 18.7303Z",
			fill: "#8A94A6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3 3.86621C12.3 3.42438 11.9418 3.06621 11.5 3.06621C11.0582 3.06621 10.7 3.42438 10.7 3.86621L12.3 3.86621ZM10.7 4.81066L10.7 5.61066L12.3 5.61066L12.3 4.81066L10.7 4.81066ZM10.7 3.86621L10.7 4.81066L12.3 4.81066L12.3 3.86621L10.7 3.86621Z",
			fill: "#8A94A6"
		})
	]
});
const ForwardRef = forwardRef(SvgPastTestResults);
export { ForwardRef as ReactComponent };
